import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_lg, font_md, fontH3 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;

  .GoogleWorkspaceIntegrationCard-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing(3)};
    min-height: ${spacing(12)};
    margin-bottom: ${spacing(7)};
  }

  .GoogleWorkspaceIntegrationCard-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
  }

  .GoogleWorkspaceIntegrationCard-icon img,
  .GoogleWorkspaceIntegrationCard-icon svg {
    width: 48px;
    height: 48px;
  }

  .GoogleWorkspaceIntegrationCard-copy {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${spacing(5)};
  }

  .GoogleWorkspaceIntegrationCard-copy h2 {
    ${fontH3};
  }

  .GoogleWorkspaceIntegrationCard-copy p {
    ${font_lg};
  }

  .GoogleWorkspaceIntegrationCard-readonly {
    display: flex;
    align-items: center;
    gap: ${spacing(1)};
    ${font_md};
  }

  .GoogleWorkspaceIntegrationCard-readonly {
    margin-left: auto;
    color: ${text_colorTextSecondary};
  }
`
